var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page-title-header"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("全系統設定")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("全模組列表")])], 1)], 1)]), _c('b-card', [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("全模組列表")]), _c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_c('AppSingleSelect', {
    staticClass: "mr-1",
    attrs: {
      "options": _vm.tableOptions
    },
    on: {
      "input": _vm.tableChange
    },
    model: {
      value: _vm.selectedTable,
      callback: function callback($$v) {
        _vm.selectedTable = $$v;
      },
      expression: "selectedTable"
    }
  }), _vm.checkPermission([_vm.consts.ORGANIZATION_MODULE_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'OrganizationModuleCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增模組")]) : _vm._e(), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入模組名稱"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-card-text', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.organizationModules,
      "fields": _vm.fields
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [data.item.table !== 'modules' ? _c('div', [_vm._v(" " + _vm._s(data.item.name) + " ")]) : _c('router-link', {
          attrs: {
            "to": {
              name: 'OrganizationModuleChildrenList',
              params: {
                parent_id: data.item.id,
                table: data.item.table
              }
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.name) + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.ORGANIZATION_MODULE_LIST_VIEW]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'OrganizationModuleView',
              params: {
                organization_module_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.ORGANIZATION_MODULE_MODIFY]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'OrganizationModuleEdit',
              params: {
                organization_module_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.ORGANIZATION_MODULE_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteOrganizationModule(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "update:currentPage": function updateCurrentPage($event) {
        return _vm.$set(_vm.query, "page", $event);
      },
      "update:current-page": function updateCurrentPage($event) {
        return _vm.$set(_vm.query, "page", $event);
      },
      "update:perPage": function updatePerPage($event) {
        return _vm.$set(_vm.query, "per_page", $event);
      },
      "update:per-page": function updatePerPage($event) {
        return _vm.$set(_vm.query, "per_page", $event);
      }
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }